/**
 * @file     pxa/index.js - top-level module for pxa, becomes dcp.identity.pxa entry point in dcp-client
 * @author   Wes Garland, wes@distributive.network
 * @date     Aug 2025
 */ 
exports.operationKeyNames = null; /* plumbed by operations module */
exports.operations = require('./operations');
exports['operation-key'] = require('./operation-key');

exports.isValidOperationKeyName = function pxa$$isValidOperationKeyName(name)
{
  var graphBranch = exports.operations;
  for (let components = name.split('.'); components.length; components.shift())
  {
    if (!graphBranch.hasOwnProperty(components[0]))
      return false;
    graphBranch = graphBranch[components[0]];
  }

  return graphBranch;
}
